import BaseService from './BaseService'
import axios from 'axios'

export default class ChatService extends BaseService {
  static async listRooms () {
    const resp = await axios.get('/api/v1/protected/chats')
    return this.parseResponse(resp, false)
  }

  static async getMessages (roomId, limit = 50) {
    const resp = await axios.get(`/api/v1/protected/chats/${roomId}/messages`, {
      params: { limit },
    })
    return this.parseResponse(resp, false)
  }

  static async sendMessage (roomId, body, replyToId = null) {
    const resp = await axios.post(`/api/v1/protected/chats/${roomId}/messages`, {
      message: { body, reply_to_id: replyToId },
    })
    return this.parseResponse(resp, false)
  }

  static async getSystemPlayers () {
    const resp = await axios.get('/api/v1/protected/chats/system_players')
    return this.parseResponse(resp, false)
  }

  static async getGlobalPlayers () {
    const resp = await axios.get('/api/v1/protected/chats/global_players')
    return this.parseResponse(resp, false)
  }

  static async requestPrivateChat (targetUserId) {
    const resp = await axios.post('/api/v1/protected/chats/private_handshakes', {
      target_user_id: targetUserId,
    })
    return this.parseResponse(resp, false)
  }
}
